import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { FloatingDropdown } from '..';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { getFloatingDropdownTestProps } from './test-props';
import { FloatingDropdownProps } from './types';
import { classes } from './FloatingDropdown.visual.st.css';

class FloatingDropdownVisual extends React.Component<any> {
  props = getFloatingDropdownTestProps();
  render() {
    return (
      <VisualTestContainer>
        <FloatingDropdown {...this.props} />
      </VisualTestContainer>
    );
  }
}

const veryLongText = 'Some very very very very very very very very long text';

const extendedProps: Partial<FloatingDropdownProps> = {
  forceContentElementVisibility: true,
};
const preselectedProps: Partial<FloatingDropdownProps> = { value: '3' };

visualize('FloatingDropdown', () => {
  story('basic', () => {
    snap(
      'default',
      <FloatingDropdownVisual {...getFloatingDropdownTestProps()} />
    );

    snap(
      'expanded',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({ ...extendedProps })}
      />
    );

    snap(
      'ellipsis',
      <div style={{ width: 200 }}>
        <FloatingDropdownVisual
          {...getFloatingDropdownTestProps({
            options: [{ id: '1', value: veryLongText, isSelectable: true }],
            value: '1',
          })}
        />
      </div>
    );
  });

  story('removeElementMinWidth', () => {
    snap(
      'default',
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <FloatingDropdownVisual
          {...getFloatingDropdownTestProps({
            removeElementMinWidth: true,
          })}
        />
      </div>
    );

    snap(
      'expanded',
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          padding: '10px',
        }}
      >
        <FloatingDropdownVisual
          {...getFloatingDropdownTestProps({
            ...extendedProps,
            removeElementMinWidth: true,
            placement: 'bottom-end',
          })}
        />
      </div>
    );

    snap(
      'displayBlock expanded',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({
          ...extendedProps,
          removeElementMinWidth: true,
          displayBlock: true,
          placement: 'bottom-end',
        })}
      />
    );
  });

  story('preselected', () => {
    snap(
      'default',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({ ...preselectedProps })}
      />
    );

    snap(
      'expanded',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({
          ...preselectedProps,
          ...extendedProps,
        })}
      />
    );
  });

  story('disabled', () => {
    snap(
      'default',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({ disabled: true })}
      />
    );
  });

  story('displayBlock', () => {
    snap(
      'default',
      <FloatingDropdownVisual
        {...getFloatingDropdownTestProps({ displayBlock: true })}
      />
    );

    snap(
      'mobile',
      <TPAComponentsProvider value={{ mobile: true }}>
        <FloatingDropdownVisual
          {...getFloatingDropdownTestProps({ displayBlock: true })}
        />
      </TPAComponentsProvider>
    );
  });

  story('native', () => {
    snap(
      'default',
      <TPAComponentsProvider value={{ mobile: true }}>
        <FloatingDropdownVisual {...getFloatingDropdownTestProps()} />
      </TPAComponentsProvider>
    );
  });
  story('item text color overrides', () => {
    snap(
      'expanded',
      <FloatingDropdownVisual
        className={classes.floatingDropdownTextOverrides}
        {...getFloatingDropdownTestProps({
          ...extendedProps,
          options: [
            {
              id: '1',
              value: 'should be green selectable',
              isSelectable: true,
            },
            { id: '2', value: 'should be red disabled', isSelectable: false },
          ],
          placeholder: 'should be blue',
        })}
      />,
    );
  });

  story('with wst variables', () => {
    snap('default', () => {
      const style = {
        '--wst-paragraph-2-color-rgb': '0,100,0',
        '--wst-paragraph-2-font-family': 'Courier New',
        '--wst-paragraph-2-font-size': '22px',
        '--wst-paragraph-2-font-weight': 'bold',
        '--wst-paragraph-2-font-style': 'italic',
        '--wst-paragraph-2-font-variant': 'small-caps',
      } as React.CSSProperties;

      return (
        <div style={style}>
          <FloatingDropdownVisual
            {...getFloatingDropdownTestProps()}
          />
        </div>
      );
    });

    snap('disabled state', () => {
      const style = {
        '--wst-system-disabled-color-rgb': '100,0,180',
      } as React.CSSProperties;

      return (
        <div style={style}>
          <FloatingDropdownVisual
            {...getFloatingDropdownTestProps()}
            disabled
          />
        </div>
      );
    });
  });
});
